export default {
    LOTTO12_BETTING_NOW: "/api/v1.0.0/betting",
    FETCH_LOTTO12V2_DRAWING_RESULT: "/api/v1.0.0/drawing/yuki",
    FETCH_LOTTO12V2_RECENT_BET_REPORT: "/api/v1.0.0/reports/recent-betting",
    FETCH_LOTTO12V2_WIN_LOSS_REPORT: "/api/v1.0.0/reports/win-lose",
    FETCH_LOTTO12V2_STATISTIC: "/api/v1.0.0/drawing/yuki-statistic",
    FETCH_LOTTO12V2_RESULT_REPORT: "/api/v1.0.0/drawing/yuki-lists",
    LOTTO12V2_FETCH_RECENT_DRAW: "/api/v1.0.0/drawing/yuki-recent-draw?size=16",
};
